import { yup } from 'common/validation/initYup';
import { ValidationSchema } from 'common/validation/ValidationSchema';
import { Type, Transform, plainToClass, classToPlain } from 'class-transformer';
import { TypeTransformDecimal } from 'common/dto/shared/types/TypeTransformDecimal';
import { Decimal } from 'decimal.js-light';
import { ApiProperty } from '@nestjs/swagger';
import type { IDto, IDtoPartial } from 'common/dto/shared/DtoInterfaces';
import { GenerateDto } from "cli/generate/decorators/GenerateDecorators";
import { SchemaLabel, SchemaPageNumber, SchemaPageSize } from "cli/generate/decorators/SchemaDecorators";
import { ColumnSortDirections } from 'client/ui/table/TableColumnSort';



@GenerateDto()
class ContractAttachmentQuery {
    @SchemaPageNumber()
    pageNumber!: number;
  
    @SchemaPageSize()
    pageSize!: number;

    @SchemaLabel("Ordinamento")
    orderBy?: string = 'createdAt';

    @SchemaLabel("Direzione di Ordinamento")
    orderByDirection?: ColumnSortDirections = ColumnSortDirections.descend;
}

/**
 * Rappresentazione DTO della classe ContractAttachmentQuery 
 * Hash: 57c8723dad7f8a85e0e000ed4923d99a
 */
@ValidationSchema(() => ContractAttachmentQuerySchema)
export class ContractAttachmentQueryDto {
  @ApiProperty({ required: false, type: Number, description: 'Numero di pagina' })
  pageNumber!: number;
  @ApiProperty({ required: false, type: Number, description: 'Dimensione pagina' })
  pageSize!: number;
  @ApiProperty({ required: false, type: String, description: 'Ordinamento' })
  orderBy?: string | undefined = 'createdAt';
  @ApiProperty({ required: false, enum: ['ASC', 'DESC'], description: 'Direzione di Ordinamento' })
  orderByDirection?: ColumnSortDirections | undefined = ColumnSortDirections.descend;

  /** Proprietà che identifica i DTO */
  readonly __dto!: any;

  /**
   * Crea una nuova istanza con i valori forniti
   */
  constructor(values?: IDtoPartial<ContractAttachmentQueryDto>) {
    if (values != null) {
      Object.assign(this, values instanceof ContractAttachmentQueryDto ? values : plainToClass(ContractAttachmentQueryDto, values));
    }
  }

  async validate(options?: any) {
    const validated = await ContractAttachmentQuerySchema.validate(classToPlain(this), options);
    return new ContractAttachmentQueryDto(validated);
  }
}

export const ContractAttachmentQuerySchema = yup
  .object({
    pageNumber: yup.number().default(1).min(1).integer().positive().label('Numero di pagina'),
    pageSize: yup.number().default(20).min(10).max(50).integer().positive().label('Dimensione pagina'),
    orderBy: yup.string().default('createdAt').label('Ordinamento'),
    orderByDirection: yup.string().oneOfEnum(ColumnSortDirections).default(ColumnSortDirections.descend).label('Direzione di Ordinamento')
  })
  .noUnknown()
  .meta({ schemaName: "ContractAttachmentQuerySchema" })
  .required();
